import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatIntlCurrency } from 'I18n/utils/formatIntlCurrency';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { HelpLink } from 'foundations-components/transitional/components/HelpLink';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { BreezeOveragePricingModelMap } from '../../constants/BreezeIntelligenceConstants';
import { MERCH_CARD } from '../../constants/tracking/TrackingSources';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { productSelector } from '../../selectors/ProductsSelectors';
import { trackTooltipInteraction } from '../../utils/tracking/trackingEventUtils';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import { MicroCopy } from './price-display/PriceStyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BreezeTileDisclaimer = ({
  apiName,
  trackingSource = MERCH_CARD
}) => {
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const overageApiName = apiName in BreezeOveragePricingModelMap ? BreezeOveragePricingModelMap[apiName] : undefined;
  const currencyCode = useDisplayedCurrencyCode();
  const overagePrice = useAppSelector(state => {
    var _productSelector;
    if (!overageApiName) return null;
    const overageSkuId = (_productSelector = productSelector(state, {
      apiName: overageApiName
    })) === null || _productSelector === void 0 ? void 0 : _productSelector.currentSkuId;
    return calculatedPriceSelector(state, {
      productConfigurations: overageSkuId ? [createProductConfig({
        skuId: overageSkuId
      })] : [],
      queryParamTerm,
      displayedCurrencyCode: currencyCode
    }).oneTimeFee.calculatedPrice;
  });
  const onOpenChange = evt => {
    trackTooltipInteraction({
      action: evt.currentTarget.value ? 'click to open' : 'click to close',
      name: 'overage-charge-disclaimer-tooltip',
      trackingSource,
      activeCurrencyCode: currencyCode,
      productName: overageApiName
    });
  };
  return /*#__PURE__*/_jsx(MicroCopy, {
    use: "help",
    children: overagePrice ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        space: "300"
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "merchCards.breezeTile.disclaimer.additionalOverageCharges_jsx",
        elements: {
          UIHelpLink: HelpLink
        },
        options: {
          content: {
            header: /*#__PURE__*/_jsx(Text, {
              as: "h4",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "merchCards.breezeTile.disclaimer.content.header"
              })
            }),
            body: /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "merchCards.breezeTile.disclaimer.content.body",
                options: {
                  price: formatIntlCurrency(overagePrice, {
                    currencyCode
                  })
                }
              })
            })
          },
          onOpenChange
        }
      })]
    }) : null
  });
};
export default BreezeTileDisclaimer;